<template>
	<div>
		<agent-resources />
		<!-- <policy-info /> -->
		<latest-news />
	</div>
</template>

<script>
// Widgets
// import PolicyInfo from './Widgets/PolicyInfo.vue';
import AgentResources from './Widgets/AgentResources.vue';
import LatestNews from './Widgets/LatestNews.vue';

export default {
	name: 'Sidebar',
	components: {
		// PolicyInfo,
		AgentResources,
		LatestNews,
	},
};
</script>

<style lang="scss"></style>
